<template>
  <v-card width="350">
    <v-col align="center">
      <h3 class="mt-5 mb-2" align="center">{{ $t("lake.title") }}</h3>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("lake.latitude") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ latitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("lake.longitude") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ longitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("lake.name") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ name }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">{{ $t("lake.district") }}</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ district_name }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-btn
            color="warning"
            style="color: black"
            @click="$emit('open-appeal')"
            >{{ $t("lake.reportError") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import Vue from "vue";
import { URL_API } from "@/settings/apiConnect";

export default {
  name: "PondPassport",

  props: {
    saveWater: Function,
    deleteWater: Function,
    properties: Object,
    isDraw: Boolean
  },

  data() {
    return {
      plantingDateMenu: false,
      passport_pondtype: [],
      passport_serviceorganization: [],
      passport_belonging: [],

      name: null,
      presence_of_flow: null,
      inflowing_rivers: null,
      outflowing_rivers: null,
      latitude: null,
      longitude: null,
      cachment_area: null,
      surface_area: null,
      shoreline_length: null,
      length: null,
      width: null,
      average_depth: null,
      maximum_depth: null,
      water_mass: null,
      district_id: null,
      serviceorganizations: [],

      district_name: null
    };
  },

  methods: {
    saveClick() {
      const data = {
        name: this.name,
        presence_of_flow: this.presence_of_flow,
        inflowing_rivers: this.inflowing_rivers,
        outflowing_rivers: this.outflowing_rivers,
        latitude: this.latitude,
        longitude: this.longitude,
        cachment_area: this.cachment_area,
        surface_area: this.surface_area,
        shoreline_length: this.shoreline_length,
        length: this.length,
        width: this.width,
        average_depth: this.average_depth,
        maximum_depth: this.maximum_depth,
        water_mass: this.water_mass,
        district_id: this.district_id,
        serviceorganizations: this.serviceorganizations
      };

      this.saveWater(data);
    },
    deleteClick() {
      this.deleteWater();
    },
    clearData() {
      this.name = null;
      this.presence_of_flow = null;
      this.inflowing_rivers = null;
      this.outflowing_rivers = null;
      this.latitude = null;
      this.longitude = null;
      this.catchment_area = null;
      this.surface_area = null;
      this.shoreline_length = null;
      this.length = null;
      this.width = null;
      this.average_depth = null;
      this.maximum_depth = null;
      this.water_mass = null;
      this.district_id = null;
      this.serviceorganizations = [];
    }
  },

  async mounted() {
    let response = await Vue.axios.get(`${URL_API}serviceorganization`);
    this.passport_serviceorganization = response.data;

    if (this.properties && this.properties[0]) {
      response = await Vue.axios.get(
        `${URL_API}lake/view/${this.properties[0]}`
      );
      const data = response.data;
      this.name = data.name;
      this.presence_of_flow = data.presence_of_flow;
      this.inflowing_rivers = data.inflowing_rivers;
      this.outflowing_rivers = data.outflowing_rivers;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.cachment_area = data.cachment_area;
      this.surface_area = data.surface_area;
      this.shoreline_length = data.shoreline_length;
      this.length = data.length;
      this.width = data.width;
      this.average_depth = data.average_depth;
      this.maximum_depth = data.maximum_depth;
      this.water_mass = data.water_mass;
      this.district_id = data.district_id;
      this.serviceorganizations = data.serviceorganizations;

      if (this.district_id) {
        this.district_name = data.district.name;
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  height: 32px;
  font-size: 12px;
}

::v-deep input,
p,
.v-input,
.v-card__text,
.v-text-field >>> label {
  font-size: 12px;
}

::v-deep .v-card__text {
  padding: 0;
}

::v-deep .v-select__selections {
  flex-wrap: nowrap;
}

::v-deep .v-text-field {
  padding-top: 0;
}
</style>
